
const IcoCheck = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
/* ════════════════════════════════════════════
   STEPPER BAR (desktop)
════════════════════════════════════════════ */
export default function StepperBar({ steps, currentStep, onGoToStep }) {
  return (
    <div className="ck-stepper notranslate" translate="no">
      {steps.map((s, i) => {
        const state = i < currentStep ? 'done' : i === currentStep ? 'active' : 'pending';
        return (
          <div className="ck-step-item" key={s.key}>
            {i > 0 && <div className="ck-step-sep" />}
            <button
              className={`ck-step-btn ${state}`}
              onClick={() => state === 'done' && onGoToStep(i)}
              disabled={state === 'pending'}
            >
              <span className="ck-step-num">
                <span className="ck-step-icon-slot" aria-hidden="true">
                  {state === 'done' ? <IcoCheck /> : i + 1}
                </span>
              </span>
              <span className="ck-step-label">{s.label}</span>
            </button>
          </div>
        );
      })}
    </div>
  );
}
